<template>
  <div class="news">
    <el-form>
      <el-form-item label="新聞名稱:">
        <input
          maxlength="100"
          class="el-input__inner"
          type="text"
          v-model="news.newsName"
        />
      </el-form-item>

      <el-form-item label="新聞版塊:">
        <el-select
          v-model="news.newsBlock"
          disabled
          placeholder="請選擇新聞版塊"
        >
          <el-option label="私密相簿" value="10"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="新聞類別 ：" v-if="type === 'add'">
        <el-radio v-model="news.newsType" disabled :label="1">VIP用戶</el-radio>
      </el-form-item>

      <el-form-item label="定時發佈:">
        <el-switch active-color="#6C3DEA" v-model="timingFlag" :disabled="status==3"> </el-switch>
      </el-form-item>

      <el-form-item v-show="timingFlag" label="發佈時間:">
        <el-date-picker
          v-model="news.publishTime"
          type="datetime"
          placeholder="選擇時間"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="上傳主圖:" class="picupload">
        <el-upload
          action=""
          :http-request="uploadRequest"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :on-remove="mainHandleRemove"
          :on-error="$errorImage"
          :file-list="mainImg"
          :on-exceed="$handleExceed.bind(this, 1)"
          :on-change="handleChange"
          :before-upload="beforePicUpload.bind(this, 2)"
          :limit="1"
          accept=".jpg,.jpeg,.png"
          :multiple="false"
          name="mainPic"
          list-type="picture-card"
        >
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png格式</div>
        </el-upload>
      </el-form-item>
      <!-- :on-success='successImage' -->
      <el-form-item label="上傳相簿" class="multPicUpload">
        <el-upload
          class="upload-demo"
          action=""
          :http-request="uploadRequest"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :on-remove="handleRemove"
          :on-error="$errorImage"
          :file-list="photoList"
          :limit="500"
          :on-exceed="$handleExceed.bind(this, 500)"
          name="multipartFile"
          :before-upload="beforePicUpload.bind(this, 10)"
          accept=".jpg,.jpeg,.png"
          drag
          list-type="picture-card"
          multiple
        >
          <div class="el-upload__text">
            <i class="el-icon-upload"></i>
            <p><em style="color:#6c3dea">点击上传</em>，或者将文件拖到此处</p>
          </div>
          <div class="el-upload__tip" slot="tip">支持jpg/png格式</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="bottomBtn">
      <div class="btn" @click="submitContent()">發佈</div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import DiaMess from "@/components/dialog";

export default {
  props: ["type", "id"],
  data() {
    return {
      news: {
        newsName: "",
        newsBlock: "10",
        newsType: 1,
        publishTime: ""
      },
      mainImg: [], //主圖
      photoList: [], //相簿列表
      addList: [], //编辑时新增的图片列表，需单独传输
      delIdList: [], //编辑时删除后台传过来的图片，编辑提交时需要把id拼接传给后台
      timingFlag: false, // 定时发布flag
      userLayout: 1, //vip用戶-新聞類別
      originalPublishTime: "", //原始发布时间
      require: true, // 禁止用户连续点击，发出多次请求接口
      dialogVisible: false,
      status:"",
    };
  },
  created() {
    let _this = this;
    if (_this.type === "edit") {
      _this.getPhotoDetails();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 编辑获取相簿详情
    getPhotoDetails() {
      let _this = this;
      _this
        .$get(`/request/privateAlbum/${_this.id}`, _this.$GLOBAL.jsonConfig)
        .then(res => {
          console.log(res);
          if (res.code === "00000") {
            _this.status = res.data.status;
            let timeFormat = _this.$compareTime(
              res.data.publishDate,
              new Date()
            );
            if (
              res.data.publishDate === null ||
              res.data.publishDate === "" ||
              timeFormat === false
            ) {
              _this.timingFlag = false;
            } else {
              _this.timingFlag = true;
            }
            _this.originalPublishTime = _this.$getTime(res.data.publishDate); //保存原始发布时间
            _this.news.publishTime = _this.$getTime(res.data.publishDate);
            _this.news.newsName = res.data.privateAlbumName; //相簿名称
            _this.mainImg.push({ name: "img.jpg", url: res.data.imageMain }); //相簿主图
            document.getElementsByClassName("el-upload")[0].style.display =
              "none";
            let photoList = res.data.privateAlbumImage;
            for (let i in photoList) {
              photoList[i].name = "img.jpeg";
              photoList[i].url = photoList[i].photoImg;
            }
            _this.photoList = photoList; //相簿列表
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 上传图片之前的回调函数
    beforePicUpload(num, file) {
      let _this = this;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < Number(num);
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片只能是jpg或者png格式", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage(
          `上傳圖片大小不能超過${num}MB!`,
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );
        return false;
      }
      const isWidth = new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          if (img.width > 3000 || file.size > 1024 * 1024 * 2) {
            _this.$imageConversion
              .compress(file, {
                quality: 0.3,
                width: 3000
              })
              .then(res => {
                resolve(res);
              });
          } else {
            resolve(file);
          }
        };
        img.src = _URL.createObjectURL(file);
      });
      return isJPG && isLt2M && isWidth;
    },
    // 移除图片的回调函数
    mainHandleRemove(file, fileList) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.mainImg);
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
    },
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        const fileWay = "resource/photos/";
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client
            .multipartUpload(fileName, file, {
              headers: { "Cache-Control": "public" }
            })
            .then(
              val => {
                if (val.res.statusCode === 200) {
                  if (option.filename == "mainPic") {
                    self.mainImg.push({
                      name: "img.jpg",
                      url:
                        self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic
                    });
                    //cdn预热
                    self.$cdnFun(self.mainImg[0].url).then(res => {
                      console.log(res);
                    });
                    document.getElementsByClassName(
                      "el-upload"
                    )[0].style.display = "none";
                  } else {
                    if (self.type === "add") {
                      self.photoList.push({
                        name: file.name,
                        url:
                          self.$GLOBAL.picFileUrl +
                          val.name +
                          self.$GLOBAL.xwPic
                      });
                      console.log(self.photoList);
                      //cdn预热
                      self
                        .$cdnFun(self.photoList[self.photoList.length - 1].url)
                        .then(res => {
                          console.log(res);
                        });
                    } else {
                      self.photoList.push({
                        name: file.name,
                        url:
                          self.$GLOBAL.picFileUrl +
                          val.name +
                          self.$GLOBAL.xwPic
                      });
                      self
                        .$cdnFun(self.photoList[self.photoList.length - 1].url)
                        .then(res => {
                          console.log(res);
                        });
                      self.addList.push({
                        name: file.name,
                        url:
                          self.$GLOBAL.picFileUrl +
                          val.name +
                          self.$GLOBAL.xwPic,
                        uid: file.uid
                      });
                    }
                    if (self.photoList.length === 500) {
                      document.getElementsByClassName(
                        "el-upload"
                      )[1].style.display = "none";
                    }
                  }
                  return val;
                } else {
                  option.onError("上传失败1");
                }
              },
              err => {
                console.log(err);
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    // 相簿列表
    // 移除图片的回调函数
    handleRemove(file, fileList) {
      if (file && file.status === "success") {
        let _this = this;
        if (_this.type === "edit") {
          //有ID即为后台传过来的图片，需要调用接口删除
          if (file.id) {
            _this.delIdList.push(file.id);
            _this.$deleteUidItem(file.uid, _this.photoList);
            console.log(_this.delIdList);
          } else {
            console.log(_this.photoList);
            //没有id即为本地新增图片，无需调接口删除，只需addList删除
            _this.$deleteUidItem(file.uid, _this.photoList);
            for (var key in _this.addList) {
              if (_this.addList[key].url === file.url) {
                _this.addList.splice(key, 1);
                console.log(_this.addList);
              }
            }
          }
        } else {
          _this.$deleteUidItem(file.uid, _this.photoList);
        }
      }
    },
    // 图片列表发生改变的回调函数
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    // 提交内容
    submitContent() {
      let _this = this;
      if (
        _this.news.newsName === "" ||
        _this.$getCaption(_this.news.newsName)
      ) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "新聞名稱不能為空或者含有非法字符",
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );
        return false;
      }
      if (_this.mainImg.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage("主圖不能為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.photoList.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage("相簿列表不能為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      this.$confirm("是否發佈該相簿?發佈後將在相簿列表展示該相簿", "提示信息", {
        confirmButtonText: "確認",
        cancelButtonText: "取消",
        center: true,
        closeOnClickModal: false
      })
        .then(() => {
          // 确认發佈的回调
          if (_this.require) {
            _this.require = false;
            // 新增相簿提交
            if (_this.type === "add") {
              let photoListStr = [];
              for (let i in _this.photoList) {
                photoListStr.push(_this.photoList[i].url);
              }
              let time, status;
              let timeFormat = _this.$compareTime(
                _this.news.publishTime,
                new Date()
              );
              if (timeFormat === false && _this.timingFlag) {
                //发布时间是过去的时间并且设置定时发布
                status = 0; //传参为即时发布
                time = _this.$formatDate(_this.news.publishTime);
              } else {
                // 即时发布 || 定时发布，发布时间为未来时间
                time = _this.timingFlag
                  ? typeof _this.news.publishTime === "string"
                    ? _this.news.publishTime
                    : _this.$formatDate(_this.news.publishTime)
                  : _this.$formatDate(new Date());
                status = _this.timingFlag ? 1 : 0;
              }
              let param = {
                articleName: _this.news.newsName,
                articleType: Number(_this.news.newsBlock),
                fireTime: status,
                imageMain: _this.mainImg[0].url,
                albumListStr: photoListStr.join("☭"),
                pushTime: time,
                oriType: 1
              };
              _this
                .$post("/request/privateAlbum", param, _this.$GLOBAL.jsonConfig)
                .then(res => {
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    _this.$propMessage("相簿發佈成功", "success", function() {
                      _this.dialogVisible = false;
                      _this.$router.push("/photoPrivacy");
                    });
                  } else if (res.code === "40002") {
                    if (res.data === "包含非法字符") {
                      _this.$propMessage(
                        "輸入內容不能包含非法字符，請重試",
                        "error",
                        function() {
                          _this.dialogVisible = false;
                        }
                      );
                    } else {
                      _this.$propMessage(res.message, "error", function() {
                        _this.dialogVisible = false;
                      });
                    }
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            } else if (_this.type === "edit") {
              let addListStr = [];
              for (let i in _this.addList) {
                addListStr.push(_this.addList[i].url);
              }
              let time, status, publishTime;
              let timeFormat = _this.$compareTime(
                _this.news.publishTime,
                new Date()
              );
              if (timeFormat === false && _this.timingFlag) {
                //发布时间是过去的时间并且设置定时发布
                status = 0;
                time =
                  typeof _this.news.publishTime === "string"
                    ? _this.news.publishTime
                    : _this.$formatDate(_this.news.publishTime);
              } else {
                // 即时发布 || 定时发布，发布时间为未来时间
                publishTime =
                  typeof _this.news.publishTime === "string"
                    ? _this.news.publishTime
                    : _this.$formatDate(_this.news.publishTime);
                time = _this.timingFlag
                  ? publishTime
                  : _this.$formatDate(new Date());
                status = _this.timingFlag ? 1 : 0;
              }
              //改变了时间传publishDate，没有改变时间传updateDate
              let param = {};
              if (_this.originalPublishTime == publishTime) {
                param = {
                  privateAlbumId: _this.id,
                  articleName: _this.news.newsName,
                  articleType: Number(_this.news.newsBlock),
                  fireTime: status,
                  imageMain: _this.mainImg[0].url,
                  albumListStr: addListStr.join("☭"), //增加的图片
                  // pushTime : time,
                  oriType: 1,
                  deletePrivateAlbumStr: _this.delIdList.join(","),
                  updateDate: publishTime
                  // status: status
                };
              } else {
                param = {
                  privateAlbumId: _this.id,
                  articleName: _this.news.newsName,
                  articleType: Number(_this.news.newsBlock),
                  fireTime: status,
                  imageMain: _this.mainImg[0].url,
                  albumListStr: addListStr.join("☭"),
                  pushTime: time,
                  oriType: 1,
                  deletePrivateAlbumStr: _this.delIdList.join(",")
                  // updateDate: publishTime,
                  // status: status
                };
              }
              // 编辑相簿提交
              _this
                .$put("/request/privateAlbum", param, _this.$GLOBAL.jsonConfig)
                .then(res => {
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    _this.$propMessage("新聞編輯成功", "success", function() {
                      _this.dialogVisible = false;
                      _this.$router.push("/photoPrivacy");
                    });
                  } else if (res.code === "40002") {
                    if (res.data === "包含非法字符") {
                      _this.$propMessage(
                        "輸入內容不能包含非法字符，請重試",
                        "error",
                        function() {
                          _this.dialogVisible = false;
                        }
                      );
                    } else {
                      _this.$propMessage(res.message, "error", function() {
                        _this.dialogVisible = false;
                      });
                    }
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            }
          }
          setTimeout(() => {
            _this.require = true;
          }, 5000);
        })
        .catch(() => {});
    }
  },
  components: {
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.contentDetails {
  .detailsContent {
    .el-form-item__content {
      white-space: pre-wrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Photo.vue